/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Stack, Tab, Typography } from '@mui/material';
import ScrollableTabs from 'components/shared/ScrollableTabs';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import {
  checkEnableParseJSON,
  dateFormat,
  formatBoolean,
  formatBooleanToYesNo,
} from 'components/helper/helper';
import LoadingContent from 'components/LoadingContent';
// import CheckboxInput from 'components/input/CheckboxInput';
import { buildPageStatusClassName } from 'screen/counselor/components/RPersonalInformation';
import CustomTabPanel from 'screen/counselor/components/TabPanel';
// import ItemContent, { CheckboxContent } from 'screen/summary/components/ItemContent';
import { testTakenOption } from 'screen/testGroup/GeneralInfo/GeneralInfo';
import testingServices from 'services/testingServices';
import SATTestSum from 'screen/summary/components/SATTestSum';
import ACTTestSum from 'screen/summary/components/ACTTestSum';
import CLEPSum from 'screen/summary/components/CLEPSum';
import { getGeneral } from 'app/testingSlice/testingSlice';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import moment from 'moment';
// import Cookies from 'js-cookie';
// import { authenticateSettings } from 'components/helper/appConfig';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { routers } from 'router/router';
import { useHistory } from 'react-router-dom';
import { PAGE_NAME, USER_ROLE } from 'constants/common';
// import { ModalCheckTestFields } from 'screen/testGroup/common/ModalCheckMissingFields';
import { usePageStatus } from 'hooks/usePageStatus';
import { toggleCounselorReviewedAndComplete } from 'services/reviewAndComplete';
import pageStatusService from 'services/pageStatusService';
import { getAccessToken, getUserRole, removeAccessToken, removeUserId } from 'utils/sessionStorage';

type Props = {
  setCurrentModuleId: (id: string) => void;
};

const TestSum = ({ setCurrentModuleId }: Props) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [value, setValue] = React.useState(1);
  const [roleTestState, setRoleTestState] = useState<any>(null);
  let token = getAccessToken();
  const params: { id?: string | number } = useParams();
  // const checkModule = useAppSelector((store) => store.basicInformation.checkModule);
  const roleTest = useAppSelector((store) => store.testing.roleTest);
  const { pageStatus } = usePageStatus({ studentId: params.id || '' });
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setCurrentModuleId(`4.${newValue}`);
  };

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  useEffect(() => {
    setRoleTestState(roleTest);
  }, [roleTest]);

  useEffect(() => {
    const getData = async () => {
      try {
        token = getAccessToken();
        if (token) {
          await dispatch(getGeneral(params.id)).unwrap();
        } else {
          handleLogout();
        }
      } catch (ex) {
        console.log('Error: ', ex);
      }
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return (
    <div>
      <ScrollableTabs
        className="mt-2"
        value={value}
        onChange={handleChange}
        variant="scrollable"
      >
        <Tab value={1} label="General" 
        // className={buildClassName('4.1', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.GENERAL_TEST)} />
        <Tab
          value={2}
          label="SAT & ACT"
          hidden={!(roleTestState?.satTest || roleTestState?.actTest)}
          // className={buildClassName('4.2', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.SAT_TEST)}
        />
        <Tab
          value={3}
          label="AP Tests"
          hidden={!roleTestState?.actSubjectTest}
          // className={buildClassName('4.3', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.ACT_SUBJECT_TEST)}
        />
        <Tab
          value={4}
          label="IB Tests"
          hidden={!roleTestState?.ibSubjectTest}
          // className={buildClassName('4.4', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.IB_SUBJECT_TEST)}
        />
        <Tab
          value={5}
          label="CLEP Tests"
          hidden={!roleTestState?.clepTest}
          //  className={buildClassName('4.5', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.CLEP_TEST)}
        />
        {/* <Tab value={6} label="Other Tests" /> */}
      </ScrollableTabs>
      <CustomTabPanel value={value} index={1}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryGeneral isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummarySATACT isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryAP isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryIB isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryCLEP isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      {/* <CustomTabPanel value={value} index={6}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
            Other Tests
          </Typography>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryOtheTestSums />
          </Stack>
        </Card>
      </CustomTabPanel> */}
    </div>
  );
};

export default TestSum;

export const SummaryGeneral = ({ isMobile }: { isMobile: boolean }) => {
  const dispatch = useAppDispatch();
  const [myGeneralState, setMyGeneralState] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  // const [show, setShow] = React.useState(false);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.GENERAL_TEST, reviewedAndComplete, setReviewedAndComplete);
  }
  // const handleClose = () => setShow(false);
  
  const myGeneral = useAppSelector((store) => store.testing.myGeneral);
  // Auto-Refresh myGeneralState

  useEffect(() => {
    setMyGeneralState({
      ...myGeneral,
    });
  }, [myGeneral]);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      //const res: any = await testingServices.getGeneral(params.id);
      const res: any = await dispatch(getGeneral(params.id)).unwrap();
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.GENERAL_TEST
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setMyGeneralState({
        ...res,
      });
      setLoading(false);
    };

    params.id !== ':id' && getData();
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          General
        </Typography>
        {/* {getUserRole() === USER_ROLE.student && (
          <Button variant="primary" onClick={() => setShow(true)}>
            Check Missing Values
          </Button>
        )} */}
      </div>
      {myGeneralState && (
        <>
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Test Reporting Preferences</div>
            <div className="gm-summary-checkbox-container">
              <div className="gm-summary-text-primary">
                In addition to sending official score reports as required by colleges, do you wish
                to self-report scores or future test dates for any of the following standardized
                tests: ACT, SAT/SAT Subject, AP, IB, CLEP, TOEFL, PTE Academic, and IELTS?*
              </div>
              <div style={{ marginTop: '8px' }}>
                <div className="gm-summary-text-dark">
                  {formatBooleanToYesNo(myGeneralState.is_wish_self_report_scores)}
                </div>
              </div>
            </div>

            {formatBoolean(myGeneralState?.is_wish_self_report_scores) === true && (
              <div className="gm-summary-conditional-section">
                <div className="gm-summary-conditional-title">Tests to Report</div>
                <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
                  Indicate all tests you wish to report.*
                </div>
                <div className="gm-summary-field-grid">
                  {testTakenOption.map((option, index) => {
                    const key = option.value;
                    var formValues: any = checkEnableParseJSON(
                      myGeneralState.all_tests_wish_report_array,
                      {}
                    );
                    const isChecked = formValues[key];
                    return (
                      <div key={index} className="gm-summary-checkbox-container">
                        <div className="gm-summary-text-primary">
                          <span
                            style={{
                              marginRight: '12px',
                              fontSize: '18px',
                              color: isChecked ? '#1890ff' : '#d9d9d9',
                              fontWeight: isChecked ? 'bold' : 'normal',
                            }}
                          >
                            {isChecked ? '✓' : '○'}
                          </span>
                          {option.label}
                        </div>
                        <div style={{ marginTop: '8px' }}>
                          <div className="gm-summary-text-dark">{formatBoolean(isChecked)}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="gm-summary-checkbox-container">
                  <div className="gm-summary-text-primary">
                    International applicants: Is promotion within your educational system based upon
                    standard leaving examinations given at the end of lower and/or senior secondary
                    school by a state or national leaving examinations board? (Students studying in
                    the US typically answer no to this question.)*
                  </div>
                  <div style={{ marginTop: '8px' }}>
                    <div className="gm-summary-text-dark">
                      {formatBooleanToYesNo(myGeneralState?.is_promotion_within_educational_system)}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
          {getUserRole() === USER_ROLE.counselor && (
            <div className="gm-summary-checkbox-container">
              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                <input
                  type="checkbox"
                  style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid #6c757d',
                    borderRadius: '2px',
                  }}
                  checked={reviewedAndComplete}
                  onClick={onReviewdAndComplete}
                />
                <span
                  style={{
                    fontSize: isMobile ? '14px' : '12px',
                    color: '#6c757d',
                    fontWeight: '500',
                  }}
                >
                  Reviewed
                </span>
              </div>
            </div>
          )}
      {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
        <ModalCheckTestFields
          show={show}
          onClose={handleClose}
          data={{
            ...myGeneralState,
            all_tests_wish_report_array: checkEnableParseJSON(
              myGeneralState?.all_tests_wish_report_array
            ),
          }}
          page="genaral"
        />
      )} */}
    </div>
  );
};

export const SummarySATACT = ({ isMobile }: { isMobile: boolean }) => {
  const [testStore, setTestStore] = React.useState<any>({ mySATTest: null, myACTTest: null });
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  // const [show, setShow] = React.useState(false);
  const [myGeneralState, setMyGeneralState] = React.useState<any>(null);
  const myGeneral = useAppSelector((store) => store.testing.myGeneral);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(
      [PAGE_NAME.SAT_TEST, PAGE_NAME.ACT_TEST],
      reviewedAndComplete,
      setReviewedAndComplete
    );
  }


  useEffect(() => {
    setMyGeneralState({
      ...myGeneral,
      all_tests_wish_report_array: checkEnableParseJSON(myGeneral?.all_tests_wish_report_array),
    });
  }, [myGeneral]);

  // const handleClose = () => setShow(false);

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const [mySATTest, myACTTest] = await Promise.all([
        testingServices.getSATTest(params.id),
        testingServices.getACTTest(params.id),
      ]);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.SAT_TEST
      );

      const pageStatusResponseACT = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.ACT_TEST
      );

      setReviewedAndComplete(pageStatusResponse?.counselor_verified && pageStatusResponseACT?.counselor_verified);
      setTestStore({ mySATTest, myACTTest });
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          SAT & ACT Tests
        </Typography>

        {/* {getUserRole() === USER_ROLE.student && (
          <Button variant="primary" onClick={() => setShow(true)}>
            Check Missing Values
          </Button>
        )} */}
      </div>

      {/* ACT Test */}
      <div className="gm-summary-section">
        {/* <div className="gm-summary-section-title">ACT Tests</div> */}
        <div className="gm-summary-field-grid">
          {testStore.myACTTest && myGeneralState?.all_tests_wish_report_array?.is_ACT && (
            <ACTTestSum data={testStore.myACTTest} />
          )}
        </div>
      </div>

      {/* SAT Test */}
      <div className="gm-summary-section">
        {/* <div className="gm-summary-section-title">SAT Tests</div> */}
        <div className="gm-summary-field-grid">
          {testStore.mySATTest && myGeneralState?.all_tests_wish_report_array?.is_SAT && (
            <SATTestSum data={testStore.mySATTest} />
          )}
        </div>
      </div>

      {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
        <ModalCheckTestFields
          show={show}
          onClose={handleClose}
          data={{
            actTest: {
              ...testStore.myACTTest,
              csu_info: testStore.myACTTest && checkEnableParseJSON(testStore.myACTTest.csu_info),
              future_testing_date_1: checkEnableParseJSON(
                testStore?.myACTTest?.future_testing_date_1
              ),
            },
            satTest: {
              ...testStore.mySATTest,
              csu_info: testStore.mySATTest && checkEnableParseJSON(testStore.mySATTest.csu_info),
              future_testing_date_1: checkEnableParseJSON(
                testStore?.mySATTest?.future_testing_date_1
              ),
            },
            myGeneral: myGeneralState,
          }}
          page="sat&act"
        />
      )} */}
      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input type="checkbox" style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderRadius: '2px' }} checked={reviewedAndComplete} onClick={onReviewdAndComplete} />
            <span style={{ fontSize: isMobile ? '14px' : '12px', color: '#6c757d', fontWeight: '500' }}>Reviewed</span>
          </div>
        </div>
      )}
    </div>
  );
};

export const SummaryAP = ({ isMobile }: { isMobile: boolean }) => {
  const [myACTSubjectTest, seMyACTSubjectTest] = React.useState<any>({
    parent1: null,
    parent2: null,
  });
  const [loading, setLoading] = React.useState(false);
  // const [show, setShow] = React.useState(false);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.ACT_SUBJECT_TEST, reviewedAndComplete, setReviewedAndComplete);
  }
  // const handleClose = () => setShow(false);

  const params: { id?: string | number } = useParams();

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const [res] = await Promise.all([testingServices.getACTSubjectTest(params.id)]);
      seMyACTSubjectTest(res);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.ACT_SUBJECT_TEST
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          AP Tests
        </Typography>

        {/* {getUserRole() === USER_ROLE.student && (
          <Button variant="primary" onClick={() => setShow(true)}>
            Check Missing Values
          </Button>
        )} */}
      </div>

      {myACTSubjectTest && (
        <div className="gm-summary-section">
          <div className="gm-summary-section-title">AP Test Information</div>

          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">AP ID</div>
              <div className="gm-summary-text-dark">
                {checkEnableParseJSON(myACTSubjectTest.csu_info)?.apId || 'N/A'}
              </div>
            </div>
          </div>

          <div className="gm-summary-table-section">
            <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
              AP Subject Tests
            </div>
            <div className="gm-summary-list">
              {checkEnableParseJSON(myACTSubjectTest.ap_test_array, []).map(
                (item: any, index: number) => {
                  const details = [];

                  if (item.examStatus === 'Completed' && item.dateTaken) {
                    details.push(moment(item.dateTaken).format(dateFormat));
                  }

                  if (item.examStatus !== 'Completed' && item.planToTakeExam) {
                    details.push(moment(item.planToTakeExam).format(dateFormat));
                  }

                  if (item.subjectCM) {
                    details.push(item.subjectCM);
                  }

                  if (item.score) {
                    details.push(`Score: ${item.score}`);
                  }

                  return (
                    <div key={index} className="gm-summary-list-item">
                      <div className="gm-summary-text-dark">{details.join(' - ')}</div>
                      <div className="gm-summary-app-icons">{renderFillAppStatus(item)}</div>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
      )}

      {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
        <ModalCheckTestFields
          show={show}
          onClose={handleClose}
          data={{
            ...myACTSubjectTest,
            ap_test_array: checkEnableParseJSON(myACTSubjectTest?.ap_test_array),
          }}
          page="ap"
        />
      )} */}
      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input type="checkbox" style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderRadius: '2px' }} checked={reviewedAndComplete} onClick={onReviewdAndComplete} />
            <span style={{ fontSize: isMobile ? '14px' : '12px', color: '#6c757d', fontWeight: '500' }}>Reviewed</span>
          </div>
        </div>
      )}
    </div>
  );
};

export const SummaryIB = ({ isMobile }: { isMobile: boolean }) => {
  const [myIBSubjectTest, setMyIBSubjectTest] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [show, setShow] = React.useState(false);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.IB_SUBJECT_TEST, reviewedAndComplete, setReviewedAndComplete);
  }
  // const handleClose = () => setShow(false);
  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await testingServices.getIBSubjectTest(params.id);
      setMyIBSubjectTest({
        ...res,
      });
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.IB_SUBJECT_TEST
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setLoading(false);
    };
    params.id !== ':id' && getData();
  }, [params.id]);

  console.log('show:', show);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          IB Tests
        </Typography>

        {getUserRole() === USER_ROLE.student && (
          <Button variant="primary" onClick={() => setShow(true)}>
            Check Missing Values
          </Button>
        )}
      </div>

      {myIBSubjectTest && (
        <div className="gm-summary-section">
          <div className="gm-summary-section-title">IB Test Information</div>

          <div className="gm-summary-checkbox-container">
            <span
              style={{
                marginRight: '12px',
                fontSize: '18px',
                color: formatBoolean(myIBSubjectTest.is_completed_full_ib) ? '#1890ff' : '#d9d9d9',
                fontWeight: formatBoolean(myIBSubjectTest.is_completed_full_ib) ? 'bold' : 'normal',
              }}
            >
              {formatBoolean(myIBSubjectTest.is_completed_full_ib) ? '✓' : '○'}
            </span>
            Check if you have completed or plan to complete the full IB diploma
          </div>

          <div className="gm-summary-table-section">
            <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
              IB Subject Tests
            </div>
            <div className="gm-summary-list">
              {checkEnableParseJSON(myIBSubjectTest.ib_test_array, []).map(
                (item: any, index: number) => {
                  return (
                    <div key={index} className="gm-summary-list-item">
                      <div className="gm-summary-text-dark">
                        {item.dateTaken && <>{moment(item.dateTaken).format('MM/DD/YYYY')} - </>}
                        {item.subject}
                        {item.score && <> - Score: {item.score}</>}
                      </div>
                      <div className="gm-summary-field-label">
                        {[item.language, item.ibExamSubjectName, item.ibExamName, item.level]
                          .filter((i) => !!i)
                          .join(' - ')}
                      </div>
                      <div className="gm-summary-app-icons">{renderFillAppStatus(item)}</div>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
      )}

      {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
        <ModalCheckTestFields
          show={show}
          onClose={handleClose}
          data={{
            ...myIBSubjectTest,
            ib_test_array: checkEnableParseJSON(myIBSubjectTest?.ib_test_array),
          }}
          page="ib"
        />
      )} */}
      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input type="checkbox" style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderRadius: '2px' }} checked={reviewedAndComplete} onClick={onReviewdAndComplete} />
            <span style={{ fontSize: isMobile ? '14px' : '12px', color: '#6c757d', fontWeight: '500' }}>Reviewed</span>
          </div>
        </div>
      )}
    </div>
  );
};

export const SummaryCLEP = ({ isMobile }: { isMobile: boolean }) => {
  const [data, setData] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  // const [show, setShow] = React.useState(false);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.CLEP_TEST, reviewedAndComplete, setReviewedAndComplete);
  }
  // const handleClose = () => setShow(false);

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res = await testingServices.getCLEPTest(params.id);
      setData(res);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.CLEP_TEST
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          CLEP Tests
        </Typography>

        {/* {getUserRole() === USER_ROLE.student && (
          <Button variant="primary" onClick={() => setShow(true)}>
            Check Missing Values
          </Button>
        )} */}
      </div>

      {data && (
        <div className="gm-summary-section">
          <div className="gm-summary-section-title">CLEP Test Information</div>
          <CLEPSum data={data?.csu_info} />
        </div>
      )}

    
      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input type="checkbox" style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderRadius: '2px' }} checked={reviewedAndComplete} onClick={onReviewdAndComplete} />
            <span style={{ fontSize: isMobile ? '14px' : '12px', color: '#6c757d', fontWeight: '500' }}>Reviewed</span>
          </div>
        </div>
      )}
    </div>
  );
};

// const SummaryOtheTestSums = () => {
//   const [testStore, setTestStore] = React.useState<any>({
//     myIELTSAndPTE: null,
//     myTOEFL: null,
//     myDouling: null,
//     myOtheTestSum: null,
//   });
//   const [loading, setLoading] = React.useState(false);
//   const params: { id?: string | number } = useParams();

//   React.useEffect(() => {
//     const getData = async () => {
//       setLoading(true);
//       const [myIELTSAndPTE, myTOEFL, myDouling, myOtheTestSum] = await Promise.all([
//         testingServices.getIELTSAndPTE(params.id),
//         testingServices.getTOEFL(params.id),
//         testingServices.getDoulingo(params.id),
//         testingServices.getOtheTestSum(params.id),
//       ]);

//       setTestStore({ myIELTSAndPTE, myTOEFL, myDouling, myOtheTestSum });
//       setLoading(false);
//     };
//     params.id !== ':id' && getData();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [params.id]);
//   return loading ? (
//     <LoadingContent />
//   ) : (
//     <Row className="w-100">
//       {testStore.myIELTSAndPTE && <IELTSSum data={testStore.myIELTSAndPTE} />}

//       {testStore.myTOEFL && <TOEFLSum data={testStore.myTOEFL} />}

//       {testStore.myDoulingo && <DoulingoSum data={testStore.myDoulingo} />}

//       {testStore.myOtheTestSum && (
//         <>
//           <div className="fs-5 text-field-light">Senior Secondary Leaving Examinations</div>
//           <CheckboxContent
//             col={12}
//             values={testStore.myOtheTestSum.is_not_required_toefl_test}
//             label="I'm a domestic student or am not required to take the TOEFL Tests."
//           />
//           <ItemContent
//             mdCol={12}
//             label="Number of Senior Secondary Leaving Examinations you have already taken"
//             values={testStore.myOtheTestSum.number_of_time_taken_senior_secondary_exam}
//           />
//           {checkEnableParseJSON(testStore.myOtheTestSum?.examination_board) &&
//             optionValues2(testStore.myOtheTestSum.number_of_time_taken_senior_secondary_exam).map(
//               (item, index) => (
//                 <Row key={index}>
//                   <ItemContent
//                     label="Date taken"
//                     values={formatDate(
//                       checkEnableParseJSON(testStore.myOtheTestSum.senior_secondary_exam_date_taken)[
//                         index
//                       ]
//                     )}
//                   />
//                   <ItemContent
//                     label="Examination board"
//                     values={
//                       checkEnableParseJSON(testStore.myOtheTestSum?.examination_board)[index] ===
//                       'Other'
//                         ? checkEnableParseJSON(testStore.myOtheTestSum?.specify_other)[index]
//                         : checkEnableParseJSON(testStore.myOtheTestSum?.examination_board)[index]
//                     }
//                   />
//                   <ItemContent
//                     label="Academic subject"
//                     values={checkEnableParseJSON(testStore.myOtheTestSum.academic_subject)[index]}
//                   />
//                   <ItemContent
//                     label="Score"
//                     values={checkEnableParseJSON(testStore.myOtheTestSum.score)[index]}
//                   />
//                   <ItemContent
//                     label="Score Type"
//                     values={checkEnableParseJSON(testStore.myOtheTestSum.score_type)[index]}
//                   />
//                 </Row>
//               )
//             )}

//           <div className="border w-100 my-3" />
//           <div className="fs-5 text-field-light">Advanced Level Exams</div>
//           <ItemContent
//             label="Do you have any Advanced Level Exams you wish to report?"
//             values={testStore.myOtheTestSum.is_have_advanced_level_exam_wish_report}
//             mdCol={12}
//           />
//           <ItemContent
//             label="How many Advanced Level Exams would you like to report"
//             values={testStore.myOtheTestSum.number_of_advanced_level_exam_report}
//             mdCol={6}
//           />
//           <ItemContent
//             label="Advanced Level Exams (AL Exam - Grade)"
//             values={checkEnableParseJSON(testStore.myOtheTestSum.advanced_level_exam_array).map(
//               (item: any) => `${item.alExam} - ${item.grade} (${formatDate(item.dateTaken)})`
//             )}
//           />
//           <ItemContent
//             label="Do you have any Predicted Advanced Level Exam Grades you wish to report?"
//             values={testStore.myOtheTestSum.is_have_predicted_advanced_level_exam_wish_report}
//             mdCol={6}
//           />
//           <ItemContent
//             label="How many Predicted Advanced Level Exams would you like to report?"
//             values={testStore.myOtheTestSum.number_of_predicted_advanced_level_exam_report}
//             mdCol={6}
//           />
//           <ItemContent
//             label="Predicted Advanced Level Exams (AL Exam - Grade)"
//             values={checkEnableParseJSON(
//               testStore.myOtheTestSum.predicted_advanced_level_exam_array
//             ).map(
//               (item: any) =>
//                 `${item.alExam} - ${item.predictedGrade} (${formatDate(item.dateTaken)})`
//             )}
//             mdCol={12}
//           />
//         </>
//       )}
//     </Row>
//   );
// };
const renderFillAppStatus = (item: any) => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      {/* {item.isIncludeIntoCommonApp && (
        <img
          alt="cm"
          src="/assets/icons/icon-cm.svg"
          style={{ marginTop: '-8px', marginLeft: '4px' }}
        />
      )}
      {item.isIncludeIntoUCApp && (
        <img
          alt="uc"
          src="/assets/icons/icon-uc.svg"
          style={{ marginTop: '-8px', marginLeft: '4px' }}
        />
      )} */}
      {/* {item.isIncludeIntoCSUApp && (
        <img
          alt="csu"
          src="./assets/icons/icon-csu-5.svg"
          style={{ marginTop: '-8px', marginLeft: '4px' }}
        />
      )} */}
      {item.isIncludeIntoCommonApp && (
        <span className="span-cm-logo " style={{ marginRight: '10px' }}></span>
      )}
      {item.isIncludeIntoUCApp && (
        <span className="span-uc-logo " style={{ marginRight: '10px', marginLeft: '10px' }}></span>
      )}
      {item.isIncludeIntoCSUApp && (
        <span className="span-csu-logo " style={{ marginRight: '10px', marginLeft: '10px' }}></span>
      )}
    </div>
  );
};
